<div class="login-wrapper">
  <div class="login-card">
    <h2>Welcome</h2>
    <img src="/logo.png" alt="Logo" class="card-img" />
    <p>Please sign in with Google to continue.</p>
    <button mat-stroked-button (click)="login()">Sign in with Google</button>
  </div>
</div>
